import $ from 'jquery';

const SIDEBAR_SCROLL_SELECTOR = '.sidebar-menu-scroll';

const getSidebarScrollInstance = () => {
  const $el = $(SIDEBAR_SCROLL_SELECTOR);
  if (!$el.length) return null;

  return $el.overlayScrollbars();
};

export const updateSidebarMenuScroll = () => {
  const instance = getSidebarScrollInstance();
  if (instance) instance.update();
};

export const initSidebarMenuScroll = () => {
  const $el = $(SIDEBAR_SCROLL_SELECTOR);
  if (!$el.length) return;

  if (getSidebarScrollInstance()) {
    updateSidebarMenuScroll();
    return;
  }

  $el.overlayScrollbars({
    className: 'os-theme-sidebar',
    scrollbars: {
      autoHide: 'move',
      autoHideDelay: 600,
      clickScrolling: true,
    },
    overflowBehavior: {
      x: 'hidden',
      y: 'scroll',
    },
  });
};

const scheduleSidebarScrollUpdate = () => {
  window.requestAnimationFrame(() => {
    window.setTimeout(updateSidebarMenuScroll, 80);
  });
};

export const watchSidebarMenuScroll = () => {
  const sidebarNav = document.querySelector('.sidebar-menu-scroll .nav-sidebar');
  if (!sidebarNav || sidebarNav.dataset.scrollWatcher) return;

  sidebarNav.dataset.scrollWatcher = 'true';

  sidebarNav.addEventListener('click', (event) => {
    if (event.target.closest('.has-treeview > .nav-link')) {
      scheduleSidebarScrollUpdate();
    }
  });

  const observer = new MutationObserver((mutations) => {
    const classChanged = mutations.some(
      (mutation) => mutation.type === 'attributes' && mutation.attributeName === 'class'
    );

    if (classChanged) scheduleSidebarScrollUpdate();
  });

  sidebarNav.querySelectorAll('.has-treeview').forEach((item) => {
    observer.observe(item, { attributes: true, attributeFilter: ['class'] });
  });
};
